import { render, staticRenderFns } from "./Worker.vue?vue&type=template&id=51984734&"
import script from "./Worker.vue?vue&type=script&lang=js&"
export * from "./Worker.vue?vue&type=script&lang=js&"
import style0 from "./Worker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports